<div
  class="table"
  #tableDiv
  [id]="'table-' + table.id"
  (click)="chooseTable()"
  [ngClass]="{
    selected: isChoosen,
    not_available: !isAvailable,
    occupied: tableStatus === 4,
    one_hour_half: tableStatus === 2,
    two_hours: tableStatus === 1
  }"
  >
  @if (isParkingNeeded) {
    <div class="parking">
      <mat-icon>local_parking</mat-icon>
    </div>
  }
  @if (!isAvailable) {
    <mat-icon class="person">person</mat-icon>
  }
  @if (table) {
    <div class="number">
      {{ table.tableNumber }}
    </div>
  }
  @if (tableStatus === 1 || tableStatus === 2) {
    <div class="timer">
      {{ timeToReservation }}
    </div>
  }
</div>
